import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionTabletTransportCreationProfileItemComponent } from './action-tablet-transport-creation-profile-item/action-tablet-transport-creation-profile-item.component';
import { CommonLayoutModule, CommonUIElementsModule } from '@sdbn/common';
import { MatRippleModule } from '@angular/material/core';
import { ActionTabletModule } from '@sdbn/appclient';



@NgModule({
  declarations: [
    ActionTabletTransportCreationProfileItemComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIElementsModule,
    ActionTabletModule,
    MatRippleModule
  ]
})
export class ActionTabletTransportCreationProfileModule { }
